import { getDefaultID } from "../../core";
import { Selection } from "../../../shared-gen/Model/Selections/Selection";
import { Selections }   from "../../../shared-gen/Model/Selections/Selections";
import { EntityType }   from "../../../shared-gen/Model/Utils/EntityType";

export class SelectionsFun {

	static createNew(provider: string): Selections {
		return {
			Type: EntityType.Selections,
			ID: getDefaultID(),
			Hash: '',
			Name: '',
			ProviderID: provider,
			Machines: []
		};
	}

	/**
	 * Returns the product ID behind the given selection number,
	 * or null if none is found.
	 */
	static getProductID(_this: Selections, selectionNumber: number): string | null {
		for (const machine of _this.Machines)
			for (const row of machine.Rows)
				for (const sel of row.Columns)
					if (sel.Number == selectionNumber)
						return sel.ProductID;
		return null;
	}

	/**
	 * Returns the selection behind the given selection number,
	 * or null if none is found.
	 */
	static getSelection(_this: Selections, selectionNumber: number): Selection | null {
		for (const machine of _this.Machines)
			for (const row of machine.Rows)
				for (const sel of row.Columns)
					if (sel.Number == selectionNumber)
						return sel;
		return null;
	}

}
